<template>
  <div id="finder" v-show="showFinder" >
    <div id="closeBg" v-on:click="closeFinder"></div>
    <div id="finderWrap"  >
      <div id="finderClose"><svg id="modal-close" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path d="M 0,0 L 20,20 M 0,20 L 20,0" stroke-width=4/></path>
      </svg></div>
      <div id="finderContent">
        <div id="finderHead">
          <form class="finderBox fl" v-on:submit.stop.prevent="findByFio">
            <div class="input_box" >
              <label class="left">Поиск по ФИО клиента</label>
              <div class="inlineBoxInput">
                <input v-model="finderFio" >
              </div>
            </div>
            <div class="button" v-on:click="findByFio">Найти</div>
          </form>
          <form class="finderBox fl" v-on:submit.stop.prevent="findPasport">
            <div class="input_box" >
              <label class="left">Поиск по серии и номеру паспорта</label>
              <div class="inlineBoxInput">
                <div id="flexExample">
                  <input v-model="pasport_series" v-mask="'####'" type="number" max="9999"  style="width: 4em;">
                  <input v-model="pasport_number" v-mask="'######'" type="number" max="999999" id="pasport_number" style="width: 6em;">
                </div>
              </div>
            </div>
            <div class="button" v-on:click="findPasport">Найти</div>
          </form>
          <form class="finderBox fl"  v-on:submit.stop.prevent="findByPhone">
            <div class="input_box" >
              <label class="left">Поиск по номеру телефону</label>
              <div class="inlineBoxInput">
                <input v-model="finderPhone" v-mask="'+7 (###) ###-##-##'" >
              </div>
            </div>
            <div class="button" v-on:click="findByPhone">Найти</div>
          </form>
        </div>
        <div id="finderBody">
          <p v-show="resultArr.length === 0">{{status}}</p>
          <div v-show="resultArr.length > 0">
            <div>
              <div class="tableLine">
                <div>Номер заявки</div>
                <div>Фио Клиента</div>
                <div>Дата заявки</div>
                <div>Дата рождения</div>
                <div>Продукт</div>
                <div>Статус</div>
                <div>Доступный продукт</div>
                <div>Доступная сумма</div>
                <div>Сумма на руки клиенту</div>
                <div>Сумма на на погащение активного займа</div>
                <div>Номер ДРП/ДРЦ</div>
              </div>
            </div>
            <div>
              <div class="tableLine" v-for="request in resultArr">
                <div>{{request.Id}}</div>
                <div><span class="transformFio"> {{request.ClFullName | capitalize({ onlyFirstLetter: true })}}</span></div>
                <div>{{request.DateDemand}}</div>
                <div>{{request.ClBirthDate}}</div>
                <div>{{request.Product}}</div>
                <div>{{request.typename}}</div>
                <div>{{request.Available_Product}}</div>
                <div>{{request.MaxSum | currency(' р.', 2, { decimalSeparator: ',',thousandsSeparator: ' ',symbolOnLeft: false  })}}</div>
                <div>{{request.AmmountToClient | currency(' р.', 2, { decimalSeparator: ',',thousandsSeparator: ' ',symbolOnLeft: false  })}}</div>
                <div>{{request.SumForPretopup | currency(' р.', 2, { decimalSeparator: ',',thousandsSeparator: ' ',symbolOnLeft: false  })}}</div>
                <div>
                  <div class="drPhone">
                    <b>ДРП</b>
                    <p> {{request.drpFIO | capitalize({ onlyFirstLetter: true })}} <br/>{{request.PhoneDRP | phoneView}}</p>
                  </div>
                  <div class="drPhone">
                    <b>ДРЦ</b>
                    <p> {{request.drcFIO | capitalize({ onlyFirstLetter: true })}} <br/>{{request.PhoneDRC | phoneView}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import Vue2Filters from 'vue2-filters'

  export default {
    name: "finder",
    props:{
      showFlag:Boolean
    },
    data:function(){
      return {
        finderFio:'',
        finderPhone:'',
        resultArr:[],
        status:'',
		pasport_series:'',
		pasport_number:'',
      }
    },
    computed:{
      showFinder:function(){
        return this.showFlag;
      }
    },
	watch: {
		pasport_series(newvalue, oldvalue){
			if( newvalue.length == 4 ){
				document.getElementById('pasport_number').focus()
			}
		}
	},
    methods:{
      findByFio:function(){
        let SendData = {
          action: 'Operator_GetDemandbyParam',
          Param: this.finderFio,
          ParamType: 'Client'
        };
        this.finderRequest(SendData);
      },
      findPasport:function(){
		if(
			typeof this.pasport_series == 'string'
			&& this.pasport_series.length == 4
			&& typeof this.pasport_number == 'string'
			&& this.pasport_number.length == 6
		){
		  let SendData = {
		    action: 'Operator_GetDemandbyParam',
		    Param: '{"series":"' + this.pasport_series + '","number":"' + this.pasport_number + '"}',
		    ParamType: 'passport'
		  };
		  this.finderRequest(SendData);
		} else {
          this.status = 'Должны быть заполнены паспортные данные серия 4 символа, номер 6 символов';
		}
      },
      finderPhoneClear:function(){
        let str = this.finderPhone;
        let onlyNumber = str.replace(/\D+/g,"").slice(1);
        return onlyNumber;
      },
      findByPhone:function(){
        let SendData = {
          action: 'Operator_GetDemandbyParam',
          Param: this.finderPhoneClear(),
          ParamType: 'Phone'
        };
        this.finderRequest(SendData);
      },
      finderRequest:function (sendData) {
        this.status = 'Идет загрузка';
        this.resultArr = [];
        this.$myApi.SendRequest(sendData,this,'finderRequest',false).then((result)=>{
          if(result != undefined) {
            this.resultArr = result;
          } else {
            this.status = 'По вашему запросу не чего не найдено';
            this.resultArr = [];
          }
        }).catch((msg)=>{
          this.status = 'Ошибка, что то пошло не так';
          this.resultArr = [];
        });
      },
      closeFinder:function(){
        this.$emit('closeFinder');
      }
    },
    mixins: [Vue2Filters.mixin],
    filters:{
      phoneView:function (value) {
        let workValue = value.toString();
        if (workValue.length < 10) {
          return 'Нет телефона';
        }
        let outStr = '';
        for (let i=0;i<workValue.length;i+=1){
          switch (i) {
            case 0:
              outStr += '+7 (' + workValue[i];
              break;
            case 2:
              outStr +=workValue[i] + ') ';
              break;
            case 6:
              outStr += workValue[i] + '-';
              break;
            case 7:
              outStr += workValue[i] + '-';
              break;
            default:
              outStr += workValue[i];
              break;
          }
        }
        return outStr;
      }
    }
  }
</script>

<style scoped>
#flexExample{display:flex;align-items:center;justify-content:space-between}
  #finder{position: fixed;top:0;left:0;width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;
    z-index: 9999;}
  #finderWrap{background: white;min-width: 600px;min-height: 500px;width: 90%;position: relative}
  #finderHead{display: flex;align-items: center;justify-content: space-around;}
  #finderBody{max-height: 60vh;overflow: scroll}
  .tableLine{display: flex;align-items: stretch;justify-content: flex-start;font-size: 12px;}
  .tableLine div{box-shadow: inset 1px 1px #42b983;display: flex;align-items: center;justify-content: center;padding: 5px 0;}
  .tableLine > div:nth-child(1){width: 7%;}
  .tableLine > div:nth-child(2){width: 12%;}
  .tableLine > div:nth-child(3){width: 8%;}
  .tableLine > div:nth-child(4){width: 8%;}
  .tableLine > div:nth-child(5){width: 8%;}
  .tableLine > div:nth-child(6){width: 8%;}
  .tableLine > div:nth-child(7){width: 8%;}
  .tableLine > div:nth-child(8){width: 8%;}
  .tableLine > div:nth-child(9){width: 7%;}
  .tableLine > div:nth-child(10){width: 6%;padding: 0;}
  .tableLine > div:nth-child(11){width: 20%;padding: 0;}
  .tableLine .drPhone{flex-direction: column;width: 50%;padding: 0;box-shadow: none;}
  p{padding: 0;margin: 0;}
  #closeBg{position: absolute;top:0;left:0;width: 100%;height: 100%;background:rgba(5, 51, 37, 0.66);cursor: pointer}
  #finderClose{position: absolute;top:-40px;right: -15px; width: 30px;height: 30px;pointer-events: none}
  svg{width: 100%;height: 100%;stroke: white;}
  .finderBox{align-items: center}
  .finderBox .button{margin: 0 20px;border-top:8px solid;}
</style>
